import PropTypes          from 'prop-types';
import { useTranslation } from 'next-i18next';
import styles             from './phone-info-block.module.scss';

import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';

const PhoneInfoBlock = ({phone, onClickChangePhone, codeScope}) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.root}>
      <div className={styles.info_text}>
        {codeScope ==='call' ? t('auth.resendTitle') : 'Сейчас вам придет смс с кодом'}
      </div>
      <div className={styles.info_phone}>
        {phone}
      </div>
      <div
        className={styles.change_phone_button}
        onClick={onClickChangePhone}
      >
        <ArrowBackOutlinedIcon/>
        <span>{t('auth.changeNumber')}</span>
      </div>
      <If condition={codeScope ==='call'}>
        <div className={styles.phone_code_description}>
          {t('auth.codeInfo1')} <span style={{fontWeight: 700, fontSize: 16}}>4</span> {t('auth.codeInfo2')}
        </div>
        <div className={styles.phone_code_mask}>
          +7 *** ****-XX-XX
        </div>
      </If>
    </div>
  )
};

PhoneInfoBlock.propTypes = {
  phone: PropTypes.string.isRequired,
  onClickChangePhone:   PropTypes.func.isRequired
};

export default PhoneInfoBlock;